import reduceReducers from "reduce-reducers";

import { WEIGH_LOT_SCAN } from "constants/actionTypes";

import {
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
  apiModelOfflineCreateReducer,
  apiModelOfflineDeleteReducer,
  apiModelOfflineCommentReducer,
  bulkUpdateCases,
} from "lib/reducers";
import { deserializeWeighLotScan } from "lib/serializers/weighLotScans";

const create = apiModelOfflineCreateReducer(WEIGH_LOT_SCAN, {
  deserializer: deserializeWeighLotScan,
});

const deleteReducer = apiModelOfflineDeleteReducer(WEIGH_LOT_SCAN);

const fetch = apiModelOfflineFetchReducer(WEIGH_LOT_SCAN, {
  deserializer: deserializeWeighLotScan,
});

const update = apiModelOfflineUpdateReducer(WEIGH_LOT_SCAN, {
  deserializer: deserializeWeighLotScan,
});

const comment = apiModelOfflineCommentReducer(WEIGH_LOT_SCAN);

function bulkUpdateAndCreateReducer(state, action) {
  switch (action.type) {
    case WEIGH_LOT_SCAN.BULK_UPDATE_OR_CREATE.REQUEST: {
      return bulkUpdateCases(state, action, "byId", deserializeWeighLotScan);
    }
    default:
      return state;
  }
}

const weighLotScanReducer = reduceReducers(
  create,
  comment,
  deleteReducer,
  fetch,
  update,
  bulkUpdateAndCreateReducer,
);

export default weighLotScanReducer;
